<template>
  <div class="left400 fl">
    <div class="bor">
      <div class="tit-mod-secs clearfix">
        <h3 class="fl font-s16">通知公告</h3>
        <a :href="`/info?type=${arr[0].type}`" class="more2 font-s14" target="_blank"
          >查看更多&gt;</a
        >
      </div>
      <div class="blank20"></div>
      <superslide :options="options" class="slideBox">
        <div class="noticeList">
          <dl class="fix" v-for="(item, index) in arr" :key="index">
            <div class="blank20"></div>
            <dt>
              <a :href="`/detail?id=${item.id}`" target="_blank">
                <img :src="item.image" :alt="item.title"
              /></a>
            </dt>
            <dd>
              <a target="_blank" :title="item.title" :href="`/detail?id=${item.id}`"
                >{{item.title}}</a
              >
              <p v-html="item.content"></p>
            </dd>
            <div class="blank20"></div>
          </dl>

          <!-- <dl class="fix">
            <div class="blank20"></div>
            <dt>
              <a href="/detail?id=1" target="_blank">
                <img src="../../assets/bda.png" alt=""
              /></a>
            </dt>
            <dd>
              <a target="_blank" title="arr[0].title" href=""
                >2022年冬季财务数据分析师全国统一考试公告</a
              >
              <p>
                根据中国商业会计学会财务数据分析师考试管理委员会工作安排，现将财务数据分析师2022年度冬季全国统一考试有关事项予以公布：考试时间：初级财务数据分析师
                2022年12月17日 上午08:30—11:40。中级财务数据分析师
                2022年12月17日
                上午08:30—11:40。报考时间：2022年12月1日08：00-2022年12月9日23：59。考试形式：闭卷机考，满分100分，60分合格，各级别考试内容如下：考试地点：
                本次考试为远程机考中国商业会计学会财务数据分析师考试管理委员会2022年11月30日
              </p>
            </dd>
            <div class="blank20"></div>
          </dl>

          <dl class="fix">
            <div class="blank20"></div>
            <dt>
              <a href="/detail?id=1" target="_blank">
                <img src="../../assets/bda.png" alt=""
              /></a>
            </dt>
            <dd>
              <a target="_blank" title="arr[0].title" href=""
                >2022年冬季财务数据分析师全国统一考试公告</a
              >
              <p>
                根据中国商业会计学会财务数据分析师考试管理委员会工作安排，现将财务数据分析师2022年度冬季全国统一考试有关事项予以公布：考试时间：初级财务数据分析师
                2022年12月17日 上午08:30—11:40。中级财务数据分析师
                2022年12月17日
                上午08:30—11:40。报考时间：2022年12月1日08：00-2022年12月9日23：59。考试形式：闭卷机考，满分100分，60分合格，各级别考试内容如下：考试地点：
                本次考试为远程机考中国商业会计学会财务数据分析师考试管理委员会2022年11月30日
              </p>
            </dd>
            <div class="blank20"></div>
          </dl>

          <dl class="fix">
            <div class="blank20"></div>
            <dt>
              <a href="/detail?id=1" target="_blank">
                <img src="../../assets/bda.png" alt=""
              /></a>
            </dt>
            <dd>
              <a target="_blank" title="arr[0].title" href=""
                >2022年冬季财务数据分析师全国统一考试公告</a
              >
              <p>
                根据中国商业会计学会财务数据分析师考试管理委员会工作安排，现将财务数据分析师2022年度冬季全国统一考试有关事项予以公布：考试时间：初级财务数据分析师
                2022年12月17日 上午08:30—11:40。中级财务数据分析师
                2022年12月17日
                上午08:30—11:40。报考时间：2022年12月1日08：00-2022年12月9日23：59。考试形式：闭卷机考，满分100分，60分合格，各级别考试内容如下：考试地点：
                本次考试为远程机考中国商业会计学会财务数据分析师考试管理委员会2022年11月30日
              </p>
            </dd>
            <div class="blank20"></div>
          </dl> -->
        </div>
      </superslide>

      <div class="blank10"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    arr: {
      type: Array,
      default: () => [],
    },
  },
  setup() {},
  data() {
    return {
      options: {
        mainCell: ".noticeList",
        autoPlay: true,
        effect: "topMarquee",
        vis: 3,
        interTime: 50,
      },
    };
  },
  components: {},
};
</script>
<style lang="scss" scoped>
a,
a:link {
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  color: #04407d;
}

.left820 {
  width: 795px;
}
.left400 {
  width: 580px;
  font-family: "Microsoft YaHei", "微软雅黑" !important;
}
.left400 .bor {
  width: 580px;
  padding-top: 20px;
}
.noticeList {
  height: 440px;
  overflow: hidden;
}
.blank20 {
  clear: both;
  height: 20px;
  overflow: hidden;
  display: block;
}
.left400 dl {
  border-bottom: 1px dotted #c6c6c6;
  margin: 0 0px;
}
.left400 dl dt {
  width: 150px;
  height: 100px;
  text-align: center;
  float: left;
  margin-right: 10px;
  overflow: hidden;
}
.left400 dl dt img {
  height: 100px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.left400 dl dt :hover img {
  -webkit-transform: scale(1.06, 1.06);
  -moz-transform: scale(1.06, 1.06);
  -ms-transform: scale(1.06, 1.06);
  -o-transform: scale(1.06, 1.06);
  transform: scale(1.06, 1.06);
}
.left400 dl dd {
  width: 420px;
  float: left;
  overflow: hidden;
}
.left400 dl dd a {
  display: block;
  width: 420px;
  font: 700 15px/24px "Microsoft YaHei";
  padding-bottom: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.left400 dl dd p {
  height: 75px;
  overflow-y: hidden;
  font: 14px/24px "Microsoft YaHei";
  color: #606060;
}
.blank10 {
  clear: both;
  height: 10px;
  overflow: hidden;
  display: block;
  font-size: 1px;
}
</style>